__turbopack_context__.v({
  "button": "SampleTopCloseButton-module-scss-module__lVh-0q__button",
  "enter": "SampleTopCloseButton-module-scss-module__lVh-0q__enter",
  "exit": "SampleTopCloseButton-module-scss-module__lVh-0q__exit",
  "fade-in": "SampleTopCloseButton-module-scss-module__lVh-0q__fade-in",
  "fade-out": "SampleTopCloseButton-module-scss-module__lVh-0q__fade-out",
  "fade-out-80": "SampleTopCloseButton-module-scss-module__lVh-0q__fade-out-80",
  "icon": "SampleTopCloseButton-module-scss-module__lVh-0q__icon",
  "slide-in-from-bottom": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-in-from-bottom",
  "slide-in-from-left": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-in-from-left",
  "slide-in-from-right": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-in-from-right",
  "slide-in-from-top": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-in-from-top",
  "slide-out-to-bottom": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-out-to-bottom",
  "slide-out-to-left": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-out-to-left",
  "slide-out-to-right": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-out-to-right",
  "slide-out-to-top": "SampleTopCloseButton-module-scss-module__lVh-0q__slide-out-to-top",
  "zoom-in": "SampleTopCloseButton-module-scss-module__lVh-0q__zoom-in",
  "zoom-out": "SampleTopCloseButton-module-scss-module__lVh-0q__zoom-out",
});
